module.exports = __webpack_public_path__ + "media/images/firma-ea8fb79b45dfa6c26507104588a0965e.png";